import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuditService {

  constructor(private http: HttpClient) { }

  getPorsant(payload) {
    const params = new HttpParams()
      .set('startDate', String(payload.startDate))
      .set('endDate', String(payload.endDate))
      .set('pageSize', String(payload.pageSize))
      .set('pageNumber', String(payload.pageNumber));
    return this.http.get(environment.API_URL + '/admin/audit/specialUser/porsant', { params }).pipe(
      map((res: any) => res.data),
    );
  }
  getPaidSalaryInformation(payload) {
    const params = new HttpParams()
      .set('startDate', String(payload.startDate))
      .set('endDate', String(payload.endDate))
      .set('pageSize', String(payload.pageSize))
      .set('pageNumber', String(payload.pageNumber));
    return this.http.get(environment.API_URL + '/admin/audit/specialUser/paidSalaryInformation', { params }).pipe(
      map((res: any) => res.data),
    );
  }
}
